import script from "./TypeAheadWithQuery.vue?vue&type=script&lang=ts&setup=true"
export * from "./TypeAheadWithQuery.vue?vue&type=script&lang=ts&setup=true"

import "./TypeAheadWithQuery.vue?vue&type=style&index=0&id=ab5cab86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab5cab86"]])

export default __exports__